import React from "react";
import MDBox from "components/MDBox";
import NotificationItem from "utils/Items/NotificationItem";
import { useTheme } from "@mui/material/styles";
import MDButton from "components/MDButton";

const UserInvitationNotificationItem = ({
  key,
  title,
  inviteCode,
  isLoading,
  handleDeclineInvitation,
  handleAcceptInvitation,
}) => {
  const theme = useTheme();

  return (
    <NotificationItem
      key={key}
      disableRipple
      disableTouchRipple
      component={MDBox}
      LinkComponent={MDBox}
      sx={{
        pt: 0,
        "&:hover": { backgroundColor: "transparent" },
      }}
      title={
        <MDBox sx={{ color: theme.palette.warning.main, textWrap: "auto" }} fontSize="small">
          {title}
          <MDBox sx={{ mt: 1 }}>
            <MDButton
              color="gray80"
              size="small"
              onClick={() => handleDeclineInvitation(inviteCode)}
              disabled={isLoading}
              sx={{ mr: 1 }}
            >
              DECLINE INVITE
            </MDButton>
            <MDButton
              color="primaryRed"
              size="small"
              type="submit"
              disabled={isLoading}
              onClick={() => handleAcceptInvitation(inviteCode)}
            >
              ACCEPT INVITE
            </MDButton>
          </MDBox>
        </MDBox>
      }
      onClick={(e) => e.preventDefault()}
    />
  );
};

export default UserInvitationNotificationItem;
